<template>
	<ui-modal-template>
		<template v-slot:title>
			<span>cropspot+ Abo bestellen</span>
		</template>
		<template v-slot:content>
			<div class="px-6 mt-3 py-3">

				<div class="px-6">
					<div class="py-3">
						<p class="mb-3 text-lg font-bold">Prüfen Sie Ihre Angaben:</p>

						<p class="font-semibold">Zahlungsmethode:</p>
						<p class="flex my-2">
							<span class="flex">{{ __(selectedPaymentMethod.code)}}</span> <img class="mx-3 min-w-4 max-h-6" :src="selectedPaymentMethod.image">
						</p>

						<p v-if="selectedPaymentMethod.code === 'directdebit'">
							<span class="font-semibold">Ihre Bankverbindung:</span>
							<span class="flex">Inhaber: {{ formData.bank_account.owner }}</span>
							<span class="flex">
								IBAN: {{ formData.bank_account.iban }}
							</span>

							<span v-if="error" class="my-3 text-red-600">
								{{ error }}
							</span>
						</p>

					</div>

					<div v-if="selectedPaymentMethod.address_required" class="py-3">
						<p class="font-semibold">Ihre Rechnungsadresse:</p>
						<p class="mb-0">{{ formData.address.company_name }}</p>
						<p>{{ formData.address.street }} {{ formData.address.house_number }}</p>
						<p>{{ formData.address.postal_code }} {{ formData.address.city }}</p>
						<p>Rechnungs-Email: {{ formData.address.email }}</p>
					</div>

					<div v-if="trialAvailable" class="py-3 sm:mr-3">
						<p class="font-semibold">Hinweis</p>
						<p class="text-sm">Die kommissionsfreie Handelsmenge von 150 Tonnen steht ausschließlich bei Wahrnehmung des kosten&shy;pflichtigen Jahresabonnements zur Verfügung.</p>
						<p class="mb-3 text-sm sm:max-w-[90%]">Haben Sie Ihr cropspot+ Abo während des Testzeitraums gekündigt und bis zum Zeitpunkt der Kündigung bereits ein Handelsvolumen von 150 Tonnen erreicht, ist cropspot berechtigt, das Handelsvolumen entsprechend Ziffer 10 Abs. 7 dieser AGB nachträglich in Rechnung zu stellen.</p>
					</div>
				</div>


			</div>

			<hr class="h-0.5 bg-gray-200 text-gray-200 my-2" />

			<div class="px-6 py-6">
				<div class="px-6">

					<ui-check-group
						class="col-span-6 flex mt-2"
						v-model="formData.consent_subscription_disclaimer"
						field="consent_subscription_disclaimer"
						:form="formData"
						:required="true"
					>
						{{ __("Mir ist bekannt, dass das Abonnement nach Ablauf des Testzeitraums automatisch kostenpflichtig wird.") }}
					</ui-check-group>

					<ui-check-group
						class="col-span-6 flex mt-2"
						v-model="formData.consent_general_terms"
						field="consent_general_terms"
						:form="formData"
						:required="true"
					>
							<span class="block">
								Ich stimme den
								<a
									href="https://www.cropspot.com/agb.pdf"
									target="_blank"
									class="underline"
								>Allgemeinen Geschäftsbedingungen (AGB)
								</a> und der
								<a
									href="https://www.cropspot.com/datenschutz.pdf"
									target="_blank"
									class="underline"
								>
									Datenschutzerklärung
								</a>
								zu
							</span>
					</ui-check-group>
				</div>
			</div>
			<div class="bg-gray-100 p-6">
				<div class="flex justify-between px-6">

					<ui-button
						:disabled="loading"
						v-on:click="$bus.$emit('wizard:back', 'booking')"
						label="Zurück"
					/>

					<ui-button
						:disabled="loading"
						v-on:click="submitForm()"
						:label="trialAvailable ? wizardDeps.subscription.trialDays + ' Tage kostenlos, danach kostenpflichtig' : 'Kostenpflichtig abonnieren'"
					/>

				</div>
			</div>
		</template>
		<!-- devide -->
	</ui-modal-template>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import toast from '../../services/toast';
import {formatLocalizedNumber} from "../../cropOptions";

export default {
	props: {
		formData: Object,
		wizardDeps: Object,
		stepDeps: Object,
		loading: Boolean,
	},
	data() {
		return {
			acl: this.$inertia.page.props.acl,
			error: null,
		}
	},
	computed: {
		trialAvailable() {
			return this.acl.subscriptions_trial ?? false
		},
		price: function() {
			const price = formatLocalizedNumber(this.wizardDeps.subscription.netPrice * (1 + this.wizardDeps.subscription.tax));
			return price + ' ' + __(this.wizardDeps.subscription.currency);
		},
		selectedPaymentMethod(){
			return this.wizardDeps.paymentMethods.find((item) => item.code === this.formData.payment_method_code) ?? null
		},
	},
	methods: {
		formatLocalizedNumber,
		/**
		 * Final Wizard Step, no Param
		 *
		 * @returns {Promise<void>}
		 */
		async submitForm() {
			// todo disable button while executing
			if(this.loading){
				return;
			}

			let promise = new Promise((resolve, reject) => {
				const response = axios.patch(
					this.$route("premium.store"),
					this.formData
				);

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			this.$toast.success('Ihre Buchung war erfolgreich!');

			this.$bus.$emit("modal:close");
			this.$bus.$emit("page:content:load");
			this.$bus.$emit("page:menu:load");
		},
		onError(error) {
			const errors = error.response.data.errors;

			// todo view mit fehlern aufrufen, nicht immer gibts nur 2 steps
			if(errors['bank_account.iban'] || errors['bank_account.owner']){
				this.$bus.$emit("wizard:back", errors)
			}

			if(errors['mollie']){
				this.error = errors['mollie'][0];
			}

			this.$bus.$emit("form:invalid", errors);
		},
	},
};
</script>
